"use strict";

import angular from "angular";

import template from "./dashboard-section.component.html";
import "./dashboard-section.component.scss";

import _ from "lodash";

class DashboardSectionComponent {
    constructor($mdMedia) {
        this.$mdMedia = $mdMedia;
        this.screenSize = this.screenSizeGet();
        this.columnsSizes = [];
    }

    $onInit() {
        this.height = this.heightGet(this.height);
        this.columnsSizes = this.columns.split(",");
    }

    $onChanges(changes) {
        if (!_.isEmpty(_.get(changes, "visualizations.previousValue") || {})) {
            this.height = this.heightGet(this.height);
            this.columnsSizes = this.columns.split(",");
        }
    }

    /**
     * @public
     * Pega o valor e soma com a porcentagem do mesmo
     * @param {Number} value valor
     * @param {Number} percentage porcentagem
     * @returns {Number} valor mais a soma da porcentagem do mesmo
     */
    sumValueAndPercentage = (value) => (percentage) =>
        value * percentage + value;

    /**
     * @public
     * calcula a porcentagem do componente em relação às alturas do body, period navbar e title
     * @param {Number} height porcentagem do componente
     * @returns {Object} height% do componente em relação às alturas
     */
    heightGet(height) {
        if (typeof height === "string") return height;
        const bodyHeight = document.body.offsetHeight;

        const heightFree = bodyHeight - 160;

        const resultHeight = this.sumValueAndPercentage(
            heightFree * (height * 0.01)
        );
        const sumHeightAndPercentage = resultHeight(this.screenSize);

        if (heightFree < sumHeightAndPercentage)
            return {
                height: `${
                    typeof this.screenSize === "number"
                        ? heightFree + "px"
                        : "auto"
                }`
            };

        return `${
            typeof this.screenSize === "number"
                ? sumHeightAndPercentage + "px"
                : "auto"
        }`;
    }

    /**
     * @public
     * Verifica qual o tamanho da tela e retorna uma porcentagem
     * @returns {number || string} height% do componente em relação às alturas
     */
    screenSizeGet = () => {
        const screenList = [
            {
                isOnScreen:
                    this.$mdMedia("(max-height: 799px)") &&
                    this.$mdMedia("(min-width: 1024px)"),

                percentage: 0.6
            },
            {
                isOnScreen:
                    this.$mdMedia("(min-height: 800px)") &&
                    this.$mdMedia("(min-width: 1024px)"),

                percentage: 0.01
            }
        ];
        const screen = screenList
            .filter((screen) => screen.isOnScreen)
            .map((screen) => screen.percentage);

        return screen && screen.length > 0 ? _.head(screen) : "auto";
    };
}

export { DashboardSectionComponent };

DashboardSectionComponent.$inject = ["$mdMedia"];

const name = "dashboardSectionComponent";
const def = {
    bindings: {
        height: "<",
        columns: "<",
        visualizations: "<",
        accountingId: "<",
        currentDate: "<",
        currentFilters: "<",
        accountingData: "<",
        onOpenShowtime: "&"
    },
    controller: DashboardSectionComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
